import axios from "axios";
import { ProfileInformation } from "../../api-types/profile-information";
import { PROFILE_INFORMATION_URL } from "../utils";

export const updateProfileInformation = async (
  profileInformation: Partial<ProfileInformation>
) => {
  return await axios.patch(PROFILE_INFORMATION_URL, profileInformation);
};
